<script>
  import {
    PlusIcon,
    XIcon,
    Edit3Icon,
    ChevronsRightIcon,
    BookIcon,
  } from 'vue-feather-icons'

  export default {
    components: {
      PlusIcon,
      XIcon,
      Edit3Icon,
      ChevronsRightIcon,
      BookIcon,
    },
    props: {
      notes: {
        type: Array,
        required: true
      },
      validation: {
        type: [Array , Object],
        required: true
      },
      canRemoveAll: {
        type: Boolean,
        default: false
      },
      disableEdit: {
        type: Boolean,
        default: false
      },
    },
    computed: {},
    methods: {
      addNote() {
        this.notes.push(
          {
            title: '',
            content: '',
            is_edit: true,
            is_open: false,
          }
        );
      },
      removeNote(index) {
        this.notes.splice(index, 1)
      },
      toggleEditNote(index, toggle = true) {
        const note = this.notes[index]
        note.is_edit = toggle
        note.is_open = false
        this.$set(this.notes, index, note)
      },
      canUpdateNote(index){
        const note = this.notes[index]
        if (note && note.content){
          return true
        }
        return false
      },
      canRemove(index){
        if (this.canRemoveAll){
          return true
        }
        const usableNotes = this.notes.filter(el => el && el.content  && el.title )
        if (usableNotes && usableNotes.length > 1){
          return true
        }
        return !this.canUpdateNote(index)
      },
      canSaveNote(index){
        const note = this.notes[index]
        if (note && note.content && note.title){
          return true
        }
        return false
      },
      toggleExpandNote(index){
        const note = this.notes[index]
        this.$set(note, 'is_open', !note.is_open)
      },
    }
  }
</script>

<template>
  <div class="form-content">
    <div v-for="(note, index) in notes" :key="index">
      <div
        v-if="!note.is_edit"
        class="edit-form-item tw-flex-col md:tw-flex tw-mt-2 tw-mb-3"
        :class="{
          'md:tw-pr-24': !canRemove(index),
          'tw-pr-[8.5rem]': canRemove(index),
        }">
        <div
          class="item-info !tw-h-11"
          :class="{ 'tw-border-b': note.is_open }">
          <div class="left-ct fl-inline-center tw-px-2 tw-w-full" style="justify-content: unset">
            <BookIcon size="1.25x" class="tw-min-w-5 tw-mr-3"/><p class="tx-value mg-b-0 text-bold tw-truncate"> {{ note.title }}</p>
          </div>
          <div
            class="action-group mg-l-auto !tw-h-11"
            :class="{ 'tw-border-b tw-border-gray-300': note.is_open }">
            <button
              type="button"
              class="btn btn-icon button-action button-action-active"
              @click="toggleExpandNote(index)">
              <BaseChevronRotate
                transition-class="rotate-360-270"
                :toggle="!(note.is_open)"
                :duration="500"
                default-collapsed
              />
            </button>
            <button
              type="button"
              :disabled="disableEdit"
              class="btn btn-icon button-action button-action-positive"
              :class="{
                '!tw-rounded-br-none': !canRemove(index) && note.is_open,
              }"
              @click="toggleEditNote(index)">
              <Edit3Icon size="1x" />
            </button>
            <button
              v-if="canRemove(index)"
              type="button"
              class="btn btn-icon button-action button-action-negative"
              :class="{
                '!tw-rounded-br-none': note.is_open,
              }"
              :disabled="disableEdit"
              @click="removeNote(index)">
              <XIcon size="1x" />
            </button>
          </div>
        </div>
        <FabricCollapse
          :id="'note-collapse-' + index"
          v-model="note.is_open"
          hide-header
          :duration="500"
          class="tw-w-full show tw-justify-start">
          <div
            class="tw-px-5 tw-flex tw-items-center tw-text-base tw-py-1"
            :class="{
              'tw-mr-[-22px]': !canRemove(index),
              'tw--mr-36 md:tw--mr-28': canRemove(index),
            }">
            <ChevronsRightIcon size="1.2x" class="mn-w-18 tw-mr-3"/><p class="tw-mb-0 tw-overflow-hidden tw-break-anywhere">{{ note.content }}</p>
          </div>
        </FabricCollapse>
      </div>

      <div v-else class="border border-radius-20 my-3 pd-20 bg-gray">
        <section class="tw-flex fl-rows">
          <div class="tw-flex fl-column tw-w-full">
            <section class="tw-flex tw-flex-col md:tw-flex-row tw-w-full tw-justify-between">
              <div :class="['form-group tw-min-w-[12rem] tw-w-full md:tw-w-1/4', { 'is-invalid': validation['notes.' + index + '.title'] }]">
                <label class="label-control">Note title</label>
                <input
                  v-model="notes[index].title"
                  type="text"
                  class="form-control"
                  placeholder="Note title"/>
                <div class="invalid-feedback">
                  {{ validation['notes.' + index + '.title'] }}
                </div>
              </div>
              <div class="tw-hidden md:tw-flex md:tw-flex-col fl-inline-center md:tw-justify-around tw-pb-0">
                <button
                  v-if="canUpdateNote(index)"
                  type="button"
                  class="btn button button-dashed-positive tw-ml-2 md:tw-ml-0 tw-w-1/3 md:tw-w-40 tw-min-w-2/5 md:tw-min-w-u"
                  :disabled="!canSaveNote(index) || disableEdit"
                  @click="toggleEditNote(index, false)"> Save </button>
                <span v-if="canUpdateNote(index) && canRemove(index)" :disabled="disableEdit" class="tw-pt-0 md:tw-pt-2.5"/>
                <button
                  v-if="canRemove(index)"
                  type="button"
                  class="btn button button-dashed-danger tw-mr-2 md:tw-mr-0 tw-w-1/3 md:tw-w-40 tw-min-w-2/5 md:tw-min-w-u"
                  :disabled="disableEdit"
                  @click="removeNote(index)"> Remove </button>
              </div>
            </section>
            <div :class="['form-group mg-b-u', { 'is-invalid': validation['notes.' + index + '.content'] }]">
              <label class="label-control">Note</label>
              <textarea
                v-model="notes[index].content"
                rows="10"
                class="form-control tw-pt-3 tw-min-h-16  md:tw-min-h-12"
                placeholder="E.g. Enter notes here"></textarea>
              <div class="invalid-feedback">
                {{ validation['notes.' + index + '.content'] }}
              </div>
            </div>
            <div class="tw-flex md:tw-hidden tw-flex-row-reverse fl-inline-center tw-justify-between tw-pt-4">
              <button
                v-if="canUpdateNote(index)"
                type="button"
                class="btn button button-dashed-positive tw-ml-2 md:tw-ml-0 tw-w-1/3 md:tw-w-40 tw-min-w-2/5 md:tw-min-w-u"
                :disabled="!canSaveNote(index) || disableEdit"
                @click="toggleEditNote(index, false)"> Save </button>
              <span v-if="canUpdateNote(index) && canRemove(index)" :disabled="disableEdit" class="tw-pt-0 md:tw-pt-2.5"/>
              <button
                v-if="canRemove(index)"
                type="button"
                class="btn button button-dashed-danger tw-mr-2 md:tw-mr-0 tw-w-1/3 md:tw-w-40 tw-min-w-2/5 md:tw-min-w-u"
                :disabled="disableEdit"
                @click="removeNote(index)"> Remove </button>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="group-button">
      <button
        type="button"
        class="btn button-bd-dashed"
        :disabled="disableEdit"
        @click="addNote">
        <div class=" fl-al-center">
          <PlusIcon size="1.5x" class="custom-class float-left mr-2"></PlusIcon>
          <span class="item-text">Add Note</span>
        </div>
      </button>
    </div>
  </div>
</template>
